import { ICellRendererParams } from "ag-grid-community";
import { FC } from "react";
import styles from "components/portfolio/cellRenderer/AROffPendingCancelRenderer.module.scss";
import { AxiosInstance } from "axios";
import AuthCheck from "components/app/AuthCheck";
import { FEATURE_KEY } from "constant";
import { Button } from "@mui/material";
import { dispatchCustomEvent } from "utils";
import { AuthDetail } from "types/auth";
import { classHOC } from "components/app/ClassWrapper";

interface AROffPendingCancelRendererState {
  axios: AxiosInstance;
  authDetail: AuthDetail;
}

const AROffPendingCancelRenderer: FC<ICellRendererParams & AROffPendingCancelRendererState> = ({
  data,
  node,
  axios,
  api,
}) => {
  if (node.rowPinned) {
    return null;
  }
  const { arOffPCCount, subscriptionCount, accountKey } = data;
  const showDismiss = false;

  const dismissAlert = (accountKey: string) => () => {
    (axios as AxiosInstance)
      .post("/api/dataservice/v1/tags/dismiss-alert", {
        alert: "AROffPC",
        accountKeys: [accountKey],
      })
      .then(() => {
        const currentModel = api.getFilterModel();
        api.setFilterModel(currentModel);
        dispatchCustomEvent("AROFFPC_ALERT_COUNT_CHANGE", {
          type: "REMOVE_SINGLE",
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className={styles.content}>
      <div>
        <span className={styles.left}>{arOffPCCount > 0 ? "Yes " : "No "}</span>(
        <span className={styles.right}>
          {arOffPCCount}/{subscriptionCount}
        </span>
        )
        {showDismiss ? (
          <AuthCheck id={FEATURE_KEY.PORTFOLIO_AROFFPC_ALERT}>
            <Button
              onClick={dismissAlert(accountKey)}
              className={`${styles.alertBtn} hover-display`}
              style={{ backgroundColor: "#009ECB", color: "#ffffff" }}
            >
              Dismiss Alert
            </Button>
          </AuthCheck>
        ) : null}
      </div>
    </div>
  );
};

export default classHOC(AROffPendingCancelRenderer);
